import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import type {QuitarValidacionMasiva} from '@/hooks/bateria/use-bateria'

/** Nunca falla en bloque: cada paquete que no estaba `validado` sale omitido con su nombre y motivo. */
export function QuitarValidacionResultado({
  resultado,
  nombreDePaquete,
}: {
  resultado: QuitarValidacionMasiva
  nombreDePaquete: (paqueteId: string) => string
}) {
  const {t} = useTranslation()

  return (
    <div className="space-y-2" data-testid="quitar-validacion-resultado">
      <p className="text-sm text-foreground" data-testid="quitar-validacion-quitadas">
        {t('admin.bateria.validacion.quitadas', {count: resultado.quitadas})}
      </p>
      {resultado.omitidas.length > 0 && (
        <ul className="space-y-1.5" data-testid="quitar-validacion-omitidas">
          {resultado.omitidas.map((omitido) => (
            <li key={omitido.paquete_id} className="flex flex-wrap items-center gap-2 text-sm">
              <Tag tone="amber">{t(`admin.bateria.validacion.omision.${omitido.motivo}`)}</Tag>
              <span className="text-foreground">{nombreDePaquete(omitido.paquete_id)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
